import React, { Component } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import PropTypes from 'prop-types';

export default class ConfirmModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: true
    };

    this.confirm = this.confirm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle(result = true) {
    const { onClose } = this.props;
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen
    }));

    if (typeof onClose === 'function') {
      onClose(result);
    }
  }

  confirm() {
    this.toggle(true);
  }

  cancel() {
    this.toggle(false);
  }

  render() {
    const {
      message, title, confirmText, cancelText,
      confirmColor, cancelColor, className
    } = this.props;
    const { modalOpen } = this.state;

    let modalHeader = null;
    let cancelButton = null;

    if (title) {
      modalHeader = (
        <ModalHeader toggle={() => { this.toggle(false); }}>
          {title}
        </ModalHeader>
      );
    }

    if (cancelText) {
      cancelButton = (
        <Button color={cancelColor} onClick={this.cancel}>
          {cancelText}
        </Button>
      );
    }

    return (
      <Modal
        isOpen={modalOpen}
        toggle={() => {
          this.toggle(false);
        }}
        className={className}
      >
        {modalHeader}
        <ModalBody style={{ whiteSpace: 'pre-line' }}>{message}</ModalBody>
        <ModalFooter>
          {cancelButton}
          {' '}
          <Button color={confirmColor} onClick={this.confirm}>
            {confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmColor: PropTypes.string,
  cancelColor: PropTypes.string,
};

ConfirmModal.defaultProps = {
  title: 'Warning!',
  confirmText: 'Ok',
  cancelText: 'Cancel',
  confirmColor: 'primary',
  cancelColor: ''
};
